var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyrights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.496,
    viewBox: "0 0 19.5 19.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(-840.149 -5214.464)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M858.9,5224.211a9,9,0,1,1-9-9A9,9,0,0,1,858.9,5224.211Z",
    transform: "translate(0 0)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "C",
    transform: "translate(840.233 5214.881)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M11.668,6.943A2.9,2.9,0,0,1,12.7,8.608H11.371a1.743,1.743,0,0,0-.643-.81,1.813,1.813,0,0,0-1.049-.3,1.657,1.657,0,0,0-1.539.972,2.509,2.509,0,0,0-.225,1.1A2.486,2.486,0,0,0,8.14,10.66a1.657,1.657,0,0,0,1.539.972,1.813,1.813,0,0,0,1.049-.3,1.748,1.748,0,0,0,.643-.81H12.7a2.9,2.9,0,0,1-1.035,1.666A3.109,3.109,0,0,1,9.7,12.8a3.115,3.115,0,0,1-1.607-.409,2.787,2.787,0,0,1-1.079-1.148,3.572,3.572,0,0,1-.383-1.674,3.592,3.592,0,0,1,.383-1.683A2.8,2.8,0,0,1,8.086,6.74,3.117,3.117,0,0,1,9.7,6.331,3.1,3.1,0,0,1,11.668,6.943Z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrights);
export default __webpack_public_path__ + "static/media/Copyrights.65bc9a6b1909b84be54b8361714b3000.svg";
export { ForwardRef as ReactComponent };